<div
  class="new-conv-wrapper"
  [ngClass]="{'full-chat-view': fullChatView}"
  [style.width]="width ? width + 20 + 'px' : undefined"
  [style.left]="fullChatView && width ? 20 - width + 'px' : undefined">
  <div class="new-conv-header d-flex justify-content-between align-items-center">
    <p class="mb-0 header-text fontsize16">{{ 'view_translations.new_conversation' | translate }}</p>
    <app-circle-buttons [icon]="'cross'" [iconSize]="'6'" (emitAction)="closePopup()"> </app-circle-buttons>
  </div>
  <div class="inner-addon left-addon search-wrapper fontsize15">
    <nb-icon icon="search" pack="icomoon" class="glyphicon global-transition" [ngClass]="{'focused-icon': searchFocus}"></nb-icon>
    <input
      placeholder="{{ 'view_translations.insert_username' | translate }}"
      class="form-control searchbar-input-field btn-default-color"
      [ngClass]="{'focused' : searchFocus}"
      type="search"
      id="searchText"
      (input)="searchFilter()"
      (focus)="searchFocus = true"
      (blur)="searchFocus = false"
      [(ngModel)]="searchInput"
      autocomplete="off"
      autocorrect="off"
      spellcheck="false" />
  </div>
  <ng-container *ngIf="searchInput.length > 2">
    <div *ngIf="(usersList$ | async)?.data?.users as usersList; else loading" class="results-wrapper">
      <div class="results-container" (scroll)="handleResultsScroll($event)">
        <div *ngFor="let result of usersList" class="search-result global-transition" (click)="goToConversation(result)">
          <div class="avatar-container">
            <div class="img-wrapper">
              <img [src]="result.avatar ?? ''" class="result-search-avatar" default="{{ defaultImage }}" />
            </div>
            <div *ngIf="result.online" class="online-user"></div>
          </div>
          <div class="result-search-container">
            <div class="search-term-name fontsize14">{{ result.username }}</div>
          </div>
        </div>
      </div>
      <div *ngIf="usersList && usersList.length > 5 && !scrolledToBottom" class="list-mask"></div>
    </div>
    <ng-template #loading>
      <app-loader></app-loader>
    </ng-template>
  </ng-container>
</div>
